<article>
  <table mat-table [dataSource]="subscribers()" class="mat-table-container">
    <ng-container matColumnDef="advertiser">
      <th mat-header-cell *matHeaderCellDef>Annonceurs</th>
      <td mat-cell *matCellDef="let element">{{ element.name || '-' }}</td>
    </ng-container>
    <ng-container matColumnDef="nbrAdvertiser">
      <th mat-header-cell *matHeaderCellDef>Nombre de pubs</th>
      <td mat-cell *matCellDef="let element">
        {{ element.totalAdvertising }}
      </td>
    </ng-container>
    <ng-container matColumnDef="dominantMediatype">
      <th mat-header-cell *matHeaderCellDef>Média</th>
      <td mat-cell *matCellDef="let element">
        {{ (element.mostUsedMediaType | mediaType) || '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="mat-table-container__actions-header"
      >
        Actions
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        class="mat-table-container__actions"
      >
        <button
          [routerLink]="'/subscriber/advertisers/' + element.id + '/stats'"
          [state]="element"
          matTooltip="Détails"
        >
          <img [lazyLoad]="'assets/icons/eye.svg'" alt="detail" />
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="hoverable"
    ></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        Aucune donnée disponible
      </td>
    </tr>
  </table>
</article>
